/**
 * Controls whether or not we use server components to render product first category page and hub page
 */ export var NEXTJS_RSC_SDUI_PRODUCT_FIRST_AND_HUB_CATEGORY_PAGE_241120 = 'NEXTJS_RSC_SDUI_PRODUCT_FIRST_AND_HUB_CATEGORY_PAGE_241120';
